import React from "react";
import { array } from "prop-types";

import CustomStoryCard4 from "../../../../molecules/CustomStoryCard4";

import "./organism3.m.css";

const Organism3 = ({ stories }) => {
  const firstStory = stories[0].story;
  const secondStory = stories.length > 1 ? stories[1].story : null;

  return (
    stories.length > 0 && (
      <div styleName="base" className="organism3-wrapper">
        <CustomStoryCard4
          story={firstStory}
          headlineType={4}
          showStoryMetaInfo={true}
          className="first-card"
          widths={[120, 220, 300]}
          updatedFont={true}
        />
        {secondStory && (
          <CustomStoryCard4
            story={secondStory}
            headlineType={16}
            showStoryMetaInfo={true}
            widths={[120]}
            updatedFont={true}
            src="big-fact-org3-2nd-story"
          />
        )}
      </div>
    )
  );
};

Organism3.propTypes = {
  stories: array.isRequired
};

export default Organism3;
